export enum AddressField {
    STREET = "street",
    HOUSE_NUMBER = "houseNumber",
    ADDRESS_ADDITION = "addressAddition",
    POSTAL_CODE = "postalCode",
    CITY = "city",
    COUNTRY = "country",
}

export interface Address {
    [AddressField.STREET]: string;
    [AddressField.HOUSE_NUMBER]: string;
    [AddressField.ADDRESS_ADDITION]: string;
    [AddressField.POSTAL_CODE]: string;
    [AddressField.CITY]: string;
    [AddressField.COUNTRY]: string;
}
